import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

const CopyLinkComponent = ({ topicName }) => {
  const [copyStatus, setCopyStatus] = useState('');

  const copyToClipboard = (e) => {
    e.preventDefault();
    const link = `${window.location.protocol}//${window.location.hostname}/#?join=${topicName}`;
    navigator.clipboard.writeText(link).then(() => {
      setCopyStatus('success');
      setTimeout(() => setCopyStatus(''), 3000); // Исправлено на setCopyStatus
    }, () => {
      setCopyStatus('error');
      setTimeout(() => setCopyStatus(''), 3000); // Исправлено на setCopyStatus
    });
  };
//onClick={(e) => e.preventDefault()}
  return (
    <div className="link-container">
      <a href={`#${topicName}`} onClick={copyToClipboard}>
        {`${window.location.protocol}//${window.location.hostname}/#?join=${topicName}`}
      </a>
      <i className="material-icons copy-icon" onClick={copyToClipboard}>content_copy</i>
      {copyStatus === 'success' && (
        <span className="copy-success-message"> {/* Используем div для применения класса */}
          <FormattedMessage id="copySuccess" defaultMessage="Link copied!" />
        </span>
      )}
      {copyStatus === 'error' && (
        <FormattedMessage id="copyError" defaultMessage="Failed to copy link." />
      )}
    </div>
  );
};

export default CopyLinkComponent;
